import { motion } from "framer-motion";
import { IMAGES } from "./data";

export const WhoWeAre = () => {
  return (
    <section id="who-we-are" className="py-20 md:py-32 bg-white" data-testid="who-we-are-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-6"
          >
            <span className="text-sm text-gray-500 uppercase tracking-widest font-semibold">Who We Are</span>
            <h2 className="mt-4 font-heading text-3xl sm:text-4xl font-bold tracking-tight text-gray-900">
              A freight brokerage built on reliable execution.
            </h2>
            <p className="mt-6 text-base sm:text-lg text-gray-600 leading-relaxed">
              PrimeLane Logistics LLC is a freight brokerage company committed to providing efficient, reliable,
              and cost-effective transportation solutions across the United States.
            </p>
            <p className="mt-4 text-base sm:text-lg font-semibold text-[#FE6A04] leading-relaxed">
              We connect your freight with trusted carriers and deliver a smooth shipping experience from start to finish.
            </p>
            <a
              href="#services"
              data-testid="whoweare-cta"
              className="mt-8 inline-flex items-center px-8 py-4 bg-[#001E52] text-white font-semibold hover:bg-[#00163d] transition-colors"
            >
              Explore Our Services
            </a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.97 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-6"
          >
            <div className="overflow-hidden border border-gray-200">
              <img src={IMAGES.port} alt="Nationwide logistics operations" className="w-full h-[340px] lg:h-[420px] object-cover" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
